// These will eventually not be needed, but the trivia is nice :)

/**
 * The Date when Pay with GasBuddy reached General Availability
 */
export const PAY_PUBLIC_LAUNCH_DATE = new Date(Date.UTC(2017, 7, 28, 12, 0, 0, 0));

/**
 * The date when the GB MasterCard Credit Card reached General Availability
 */
export const CREDIT_CARD_PUBLIC_LAUNCH_DATE = new Date(Date.UTC(2022, 2, 1, 13, 0, 0));
